import API from '../../../api'
import { storage } from '../../../services/local-storage'

export default {
  state: {
    account: storage.account,
    paymentPlan: storage.paymentPlan,
    paymentClient: '',
    paymentUser: '',
    invoices: storage.invoices || []
  },
  mutations: {
    setAccount(state, account) {
      storage.account = account
      state.account = account
    },
    setInvoices(state, invoices) {
      storage.invoices = invoices
      state.invoices = invoices
    },
    setPaymentPlan(state, plan) {
      storage.paymentPlan = plan
      state.paymentPlan = plan
    },
    setPaymentClient(state, paymentClient) {
      state.paymentClient = paymentClient
    },
    setPaymentUser(state, paymentUser) {
      state.paymentUser = paymentUser
    }
  },
  actions: {
    async fetchAccount({ commit }) {
      try {
        commit('setAccount', await API.account.me())
        return true
      } catch (err) {
        throw err
      }
    },
    async fetchInvoices({ commit }) {
      try {
        commit('setInvoices', await API.account.invoices())
        return true
      } catch (err) {
        throw err
      }
    },
    async fetchPaymentPlan({ commit }) {
      try {
        commit('setPaymentPlan', await API.account.paymentPlan())
        return true
      } catch (err) {
        throw err
      }
    }
  },
  getters: {
    account(state) {
      return state.account
    },
    invoices(state) {
      return state.invoices
    },
    paymentPlan(state) {
      return state.paymentPlan
    },
    paymentClient(state) {
      return state.paymentClient
    },
    paymentUser(state) {
      return state.paymentUser
    }
  }
}
